import { NativeModules, Platform } from 'react-native';
const LINKING_ERROR = `The package 'react-native-clarity' doesn't seem to be linked. Make sure: \n\n` +
// Platform.select({ ios: "- You have run 'pod install'\n", default: '' }) + TODO: add back when iOS is supported.
'- You rebuilt the app after installing the package\n' + '- You are not using Expo Go\n';
const Clarity = NativeModules.Clarity;

/**
 * Initializes the Clarity plugin with the provided parameters.
 *
 * @param projectId     The Clarity project id to send data to.
 * @param userId        A custom identifier for the current user. If passed as undefined, the user id
 *                      will be auto generated. The user id in general is sticky across sessions.
 *                      The provided user id must follow these conditions:
 *                          1. Cannot be an empty string.
 *                          2. Should be base36 and smaller than "1Z141Z4".
 * @param logLevel      The level of logging to show in the device logcat stream ("Verbose", "Debug", "Info", "Warning", "Error", "None").
 * @param allowMeteredNetworkUsage  Allows uploading session data to the servers on device metered network.
 * @param enableWebViewCapture    Allows Clarity to capture the web views DOM content.
 * @param allowedDomains    The whitelisted domains to allow Clarity to capture their DOM content.
 *                          If it contains "*" as an element, all domains will be captured.
 */
export function initialize(projectId, userId) {
  let logLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "None";
  let allowMeteredNetworkUsage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  let enableWebViewCapture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  let allowedDomains = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ["*"];
  if (Platform.OS !== 'android') {
    console.warn("Clarity supports Android only for now.");
    return;
  }
  if (Clarity === null) {
    console.error("Clarity did not initialize properly.", LINKING_ERROR);
    return;
  }
  Clarity.initialize(projectId, userId, logLevel, allowMeteredNetworkUsage, enableWebViewCapture, allowedDomains);
}

/**
 * Sets a custom user id that can be used to identify the user. It has less
 * restrictions than the userId parameter. You can pass any string and
 * you can filter on it on the dashboard side. If you need the most efficient
 * filtering on the dashboard, use the userId parameter if possible.
 * <p>
 * Note: custom user id cannot be null or empty, or consists only of whitespaces.
 * </p>
 * @param customUserId   The custom user id to set.
 */
export function setCustomUserId(customUserId) {
  if (Platform.OS !== 'android') {
    console.warn("Clarity supports Android only for now.");
    return;
  }
  if (Clarity === null) {
    console.error("Clarity did not initialize properly.", LINKING_ERROR);
    return;
  }
  Clarity.setCustomUserId(customUserId);
}

/**
 * Returns the active session id. This can be used to correlate the Clarity session with other
 * analytics tools that the developer may be using.
 * @returns a promise that resolves to the current session id.
 */
export function getCurrentSessionId() {
  if (Platform.OS !== 'android') {
    console.warn("Clarity supports Android only for now.");
    return new Promise(resolve => {
      resolve("Undefined");
    });
  }
  if (Clarity === null) {
    console.error("Clarity did not initialize properly.", LINKING_ERROR);
    return new Promise(resolve => {
      resolve("Undefined");
    });
  }
  return Clarity.getCurrentSessionId();
}
//# sourceMappingURL=index.js.map